'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenCampus = void 0;
const $ = require("jquery");
class OpenCampus {
    constructor() {
        $('.trigCloseOpenCampusBanner').on('click', () => {
            $('.bulletOpenCampusBanner').hide();
        });
    }
}
exports.OpenCampus = OpenCampus;
exports.default = OpenCampus;
